import type { AppMenuConfig, AppMenuItem } from '../components/app-navigation';

function collectItems(items: AppMenuItem[] | undefined, lookup: Map<string, AppMenuItem>) {
  items?.forEach(item => {
    // Preserve the first occurrence (usually from sideMenu) so icon/metadata are not
    // overwritten by duplicates in other menus (e.g., topMenu/userMenu).
    if (!lookup.has(item.id)) {
      lookup.set(item.id, item);
    }
    if (item.children) {
      collectItems(item.children, lookup);
    }
  });
}

export function buildMenuLookup(config: AppMenuConfig): Map<string, AppMenuItem> {
  const lookup = new Map<string, AppMenuItem>();
  collectItems(config.sideMenu, lookup);
  collectItems(config.topMenu, lookup);
  collectItems(config.userMenu, lookup);
  return lookup;
}

export function resolveMenuItemsFromLookup(lookup: Map<string, AppMenuItem>, ids: string[]): AppMenuItem[] {
  return ids
    .map(id => lookup.get(id))
    .filter((item): item is AppMenuItem => Boolean(item))
    .map(item => ({ ...item }));
}
